import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import ReportService from '../../../services/reports';
import { normalizeReportParams } from '../../../helpers/reportQuery';
import { normalizeReportsRevenuePayload } from '../../../helpers/normalizeReportsAdminResponse';

const empty = normalizeReportsRevenuePayload({});

const initialState = {
  loading: false,
  summary: empty.summary,
  series: [],
  error: '',
};

export const fetchReportsRevenue = createAsyncThunk(
  'report/fetchReportsRevenue',
  (params = {}) =>
    ReportService.getReportsRevenue(
      normalizeReportParams({ ...params, format: 'json' })
    ).then((res) => res)
);

const revenueReportSlice = createSlice({
  name: 'revenueReport',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchReportsRevenue.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchReportsRevenue.fulfilled, (state, action) => {
      state.loading = false;
      const n = normalizeReportsRevenuePayload(action.payload);
      state.summary = n.summary;
      state.series = n.series;
      state.error = '';
    });
    builder.addCase(fetchReportsRevenue.rejected, (state, action) => {
      state.loading = false;
      state.series = [];
      state.error = action.error.message;
    });
  },
});

export default revenueReportSlice.reducer;
